<template>
  <div class="home-onboarding">
    <div class="home-onboarding__intro">{{ $t("onboarding-intro") }}</div>

    <div
      v-for="(step, index) in steps"
      :key="step.label"
      class="home-onboarding__step"
      @click="$router.push(step.path)"
    >
      <span class="home-onboarding__step-number">{{ index + 1 }}</span>
      <div class="home-onboarding__step-body">
        <div class="home-onboarding__step-title">{{ $t(step.label) }}</div>
        <div class="home-onboarding__step-desc">{{ $t(step.desc) }}</div>
      </div>
      <i class="el-icon-arrow-right home-onboarding__arrow"></i>
    </div>

    <template v-if="videos.length > 0">
      <div class="home-onboarding__videos-title">{{ $t("videos-explicativos") }}</div>
      <div class="home-onboarding__videos">
        <a
          v-for="video in videos"
          :key="video.url"
          class="home-onboarding__video"
          :href="video.url"
          target="_blank"
          rel="noopener"
        >
          <i class="el-icon-video-play"></i>{{ video.title }}
        </a>
      </div>
    </template>
  </div>
</template>

<script>
// Estado vazio como guia de ativação: cliente sem postagens não vê gráfico
// zerado — vê o caminho até a primeira etiqueta (métrica de negócio:
// tempo até a primeira postagem).
// Preencher as URLs dos vídeos quando o material estiver publicado;
// vídeos sem URL não são exibidos.
const VIDEOS = [
  { title: "Como criar sua primeira pré-postagem", url: "" },
  { title: "Importando pedidos em massa", url: "" },
  { title: "Conectando sua loja (integrações)", url: "" },
];

export default {
  name: "HomeOnboarding",
  data() {
    return {
      steps: [
        { label: "onboarding-destinatario", desc: "onboarding-destinatario-desc", path: "/cadastro/destinatario" },
        { label: "onboarding-remetente", desc: "onboarding-remetente-desc", path: "/cadastro/remetente" },
        { label: "onboarding-integracao", desc: "onboarding-integracao-desc", path: "/cadastro/integracao" },
        { label: "onboarding-etiqueta", desc: "onboarding-etiqueta-desc", path: "/servicos/prepostagem/adicionar" },
      ],
      videos: VIDEOS.filter((video) => video.url),
    };
  },
};
</script>

<style>
.home-onboarding__intro {
  color: var(--me-text-regular);
  font-size: 13px;
  margin-bottom: 14px;
}

.home-onboarding__step {
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid var(--me-border-light);
  border-radius: var(--me-radius);
  margin-bottom: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
}

.home-onboarding__step:hover {
  border-color: var(--me-primary);
  transform: translateY(-1px);
  box-shadow: var(--me-shadow-sm);
}

.home-onboarding__step-number {
  width: 26px;
  height: 26px;
  line-height: 24px;
  text-align: center;
  border: 1px solid var(--me-primary);
  border-radius: 50%;
  color: var(--me-primary);
  font-weight: 600;
  font-size: 13px;
  margin-right: 12px;
  flex-shrink: 0;
}

.home-onboarding__step-title {
  font-weight: 600;
  font-size: 13px;
  color: var(--me-text-primary);
}

.home-onboarding__step-desc {
  font-size: 12px;
  color: var(--me-text-secondary);
}

.home-onboarding__step-body {
  flex: 1;
}

.home-onboarding__arrow {
  color: var(--me-text-placeholder);
}

.home-onboarding__step:hover .home-onboarding__arrow {
  color: var(--me-primary);
}

.home-onboarding__videos-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--me-text-secondary);
  margin: 14px 0 6px;
}

.home-onboarding__video {
  display: inline-flex;
  align-items: center;
  margin: 0 14px 6px 0;
  font-size: 13px;
  color: var(--me-primary);
  cursor: pointer;
}

.home-onboarding__video i {
  margin-right: 5px;
}

.home-onboarding__video:hover {
  text-decoration: underline;
}
</style>
